import React from 'react'
import SupplierListTable from './Components/SupplierListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const SupplierList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Supplier List</HeadingOne>
          <AddItemBtn url="add-supplier" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <SupplierListTable />
      </div>
    </PageBody>
  );
};

export default SupplierList;
